import { getRequest } from '../services/requestHandler';
import { LoftsAndHandAndHeadModel } from '../models';
import { mappingLoftHandHeadModel } from '../models/LoftsByHandAndHeadModel';

export const getLoftsAndHandAndHeadModel = async () => {
  const url = `loft/getLoftsAndHandAndHeadModel`;
  const response = await getRequest<LoftsAndHandAndHeadModel>('GetLoftsAndHandAndHeadModel', url);
  let newResponse = mappingLoftHandHeadModel(response);
  return newResponse;
};
